export { AttributeListPage } from './view/attribute-list-page';

export { attributeSagas } from './sagas';
export { default as attributeSlice } from './slice';

export type { IAttribute } from './types';
